import { render, staticRenderFns } from "./DocumentManagementPane.vue?vue&type=template&id=f941ea3e&scoped=true"
import script from "./DocumentManagementPane.vue?vue&type=script&lang=js"
export * from "./DocumentManagementPane.vue?vue&type=script&lang=js"
import style0 from "./DocumentManagementPane.vue?vue&type=style&index=0&id=f941ea3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f941ea3e",
  null
  
)

export default component.exports